import React, { useState } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";
import styled from "styled-components";
import axios from "axios";
import closeIcon from "../../assets/close-circle.svg";
import * as qs from "query-string";
import Newsletter from "../../assets/Landing/newsletter.jpg";
import MelTrialImage from "../../assets/Landing/mel-signup-asset.jpg";
import NewsletterAddtionalInfo from "../newsletterAdditionalInfo";
import NewsletterConsent from "./newsletterConsent";
import {
  ErrorDiv,
  InputHeader,
  InputWrapper,
  StyledInput,
  SubmitButton,
  SubTitle,
} from "../newsletterStyles";

const NewsLetterSignUp = styled.div`
  position: fixed;
  bottom: 0px;
  right: 24px;
  z-index: 100;
  background: white;
  border-radius: 16px;
  box-shadow: 0 6px 20px 0 rgb(196 200 209 / 64%);
  max-width: 620px;
  @media (max-width: 726px) {
    width: 100%;
    right: 0px;
  }
`;

const FormWrapper = styled.div`
  padding: 28px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  color: #242d41;
`;

const StyledCloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  width: 28px;
  height: 29px;
  align-items: flex-start;
  flex-shrink: 0;
  &:focus {
    outline: none;
  }
  img {
    width: 28px;
    height: 29px;
  }
`;

const StyledImage = styled.img`
  height: 140px;
  width: 100%;
  object-fit: cover;
  object-position: 10% 14%;
`;

const StyledInputWrapper = styled(InputWrapper)`
  margin-top: 28px;
`;

const StyledSubTitle = styled(SubTitle)`
  margin-bottom: 0.5rem;
  background: #eca206;
  border-radius: 2px;
  padding: 0 4px;
  width: fit-content;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 16px;
  color: #ffffff;
`;

const LinksDiv = styled.div`
  display: flex;
  flex-direction: column;
  & li {
    color: #242d41;
    margin-bottom: 8px;
  }
  & a {
    color: #3382e6;
  }
`;

const NewsletterSignUp = ({ onClose, noNavigation }) => {
  const [emailError, setEmailError] = useState();
  const [newsletterChecked, setNewsletterChecked] = useState(true);
  const [updatesChecked, setUpdatesChecked] = useState(true);
  const [emailInput, setEmailInput] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [showAdditionalInfo, setShowAddiitonalInfo] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [company, setCompany] = useState("");

  const [emailErrorTrial, setEmailErrorTrial] = useState(false);
  const [invalidEmailError, setInvalidEmailError] = useState(false);
  const [emailInputTrial, setEmailInputTrial] = useState(null);
  const [nameInput, setNameInput] = useState(null);
  const [nameError, setNameError] = useState(false);
  const [numberInput, setNumberInput] = useState(null);
  const [submitErrorTrial, setSubmitErrorTrial] = useState(null);
  const [showConfirmationPage, setShowConfirmationPage] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleInputChangeTrial = (value, key) => {
    if (key === "email") {
      setEmailInputTrial(value);
      setInvalidEmailError(false);
      setEmailErrorTrial(false);
    }
    if (key === "name") {
      setNameInput(value);
      setNameError(false);
    }
    if (key === "number") {
      setNumberInput(value);
    }
  };

  const handleSubmitTrial = async (event) => {
    event.preventDefault();
    if (!emailInputTrial) {
      if (!emailInputTrial) setEmailErrorTrial(true);
      return;
    }
    if (!validateEmail(emailInputTrial)) {
      setInvalidEmailError(true);
      return;
    }
    if (!nameInput) {
      if (!nameInput) setNameError(true);
      return;
    }
    const formData = {
      email: emailInputTrial,
      name: nameInput,
      number: numberInput,
      identifier: "mel-manager-trial",
      "form-name": "mel-manager-trial",
    };
    const axiosOptions = {
      url: window.location.href,
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: qs.stringify(formData),
    };
    axios(axiosOptions)
      .then(() => {
        setEmailInputTrial(null);
        setNameInput(null);
        setNumberInput(null);
        setShowConfirmationPage(true);
      })
      .catch((err) => {
        console.error("Submission failed");
        const genericMessage = "Something went wrong, please try again";
        setSubmitErrorTrial(err.msg || genericMessage);
      });
  };

  const handleInputChange = (value, key) => {
    if (key === "email") {
      setEmailInput(value);
      setEmailError();
    }
    if (key === "firstName") {
      setFirstName(value);
      setSubmitError(null);
    }
    if (key === "lastName") {
      setLastName(value);
      setSubmitError(null);
    }
    if (key === "company") {
      setCompany(value);
      setSubmitError(null);
    }
    if (key === "newsletter") {
      setNewsletterChecked(value);
    }
    if (key === "updates") {
      setUpdatesChecked(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!emailInput) {
      if (!emailInput) setEmailError("This field is required.");
      return;
    }
    if (!validateEmail(emailInput)) {
      setEmailError("This must be a valid email address");
      return;
    }
    if (
      showAdditionalInfo
        ? firstName || lastname || company
        : newsletterChecked || updatesChecked
    ) {
      const result = await addToMailchimp(emailInput, {
        NEWSLETTER: newsletterChecked ? "Yes" : "No",
        INSIGHTS: updatesChecked ? "Yes" : "No",
        FNAME: firstName,
        LNAME: lastname,
        MMERGE6: company,
      });
      if (result.result === "success") {
        setSubmitError(null);
        if (showAdditionalInfo) {
          onClose();
        }
        localStorage.setItem("newletterSignUpSeen", "true");
        setShowAddiitonalInfo(true);
      } else {
        const genericMessage = "Something went wrong, please try again";
        setSubmitError(result.msg || genericMessage);
      }
    } else {
      setSubmitError(
        showAdditionalInfo
          ? "Please fill in at least one field"
          : "You must agree to at least one checkbox"
      );
    }
  };

  const renderConfirmationPage = () => {
    return (
      <div>
        <h5>Thank you for requesting a trial with us</h5>
        <p>
          One of our sales representatives will be in touch with you shortly to
          set up your trial account. In the meantime please feel free to explore
          our full line of aviation products:
        </p>
        <LinksDiv>
          <ul>
            <li>
              <a href="https://www.trustflight.com/centrik/">Centrik SMS/QMS</a>
            </li>
            <li>
              <a href="https://www.trustflight.com/techlog/">
                Electronic Tech Log
              </a>
            </li>
            <li>
              <a href="https://www.trustflight.com/reliability-analytics/">
                Reliability Analytics
              </a>
            </li>
          </ul>
        </LinksDiv>
      </div>
    );
  };

  return (
    <NewsLetterSignUp>
      <FormWrapper>
        {noNavigation ? (
          <>
            {showConfirmationPage ? (
              renderConfirmationPage()
            ) : (
              <>
                <TitleWrapper>
                  <Title>Get MEL Manager free for 14 days</Title>
                  <StyledCloseButton onClick={() => onClose()}>
                    <img src={closeIcon} alt="close icon" />
                  </StyledCloseButton>
                </TitleWrapper>
                <StyledSubTitle>Limited time only</StyledSubTitle>
                <form
                  name="mel-manager-trial"
                  method="post"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={(event) => this.handleSubmitTrial(event)}
                >
                  <input type="hidden" name="email" />
                  <input type="hidden" name="name" />
                  <input type="hidden" name="number" />
                  <input type="hidden" name="identifier" />
                  <input
                    type="hidden"
                    name="form-name"
                    value="mel-manager-trial"
                  />
                  <StyledInputWrapper>
                    <InputHeader>Email address</InputHeader>
                    <StyledInput
                      onChange={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleInputChangeTrial(e.target.value, "email");
                      }}
                      error={emailErrorTrial}
                      onClick={(e) => e.stopPropagation()}
                      name="email"
                    />
                    {emailErrorTrial ? (
                      <ErrorDiv>This field is required.</ErrorDiv>
                    ) : null}
                    {invalidEmailError ? (
                      <ErrorDiv>This must be a valid email address</ErrorDiv>
                    ) : null}
                  </StyledInputWrapper>
                  <InputWrapper>
                    <InputHeader>Name</InputHeader>
                    <StyledInput
                      onChange={(e) =>
                        handleInputChangeTrial(e.target.value, "name")
                      }
                      error={nameError}
                      onClick={(e) => e.stopPropagation()}
                      name="name"
                    />
                    {nameError ? (
                      <ErrorDiv>This field is required.</ErrorDiv>
                    ) : null}
                  </InputWrapper>
                  <InputWrapper>
                    <InputHeader>Phone number</InputHeader>
                    <StyledInput
                      onChange={(e) =>
                        handleInputChangeTrial(e.target.value, "number")
                      }
                      onClick={(e) => e.stopPropagation()}
                      name="number"
                    />
                  </InputWrapper>
                  <SubmitButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSubmitTrial(e);
                    }}
                  >
                    Start free trial
                  </SubmitButton>
                  {submitErrorTrial ? (
                    <ErrorDiv>{submitErrorTrial}</ErrorDiv>
                  ) : null}
                </form>
              </>
            )}
          </>
        ) : (
          <>
            <TitleWrapper>
              <Title>Insights from TrustFlight</Title>
              <StyledCloseButton onClick={() => onClose()}>
                <img src={closeIcon} alt="close icon" />
              </StyledCloseButton>
            </TitleWrapper>
            {showAdditionalInfo ? (
              <NewsletterAddtionalInfo
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                submitError={submitError}
              />
            ) : (
              <NewsletterConsent
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                submitError={submitError}
                newsletterChecked={newsletterChecked}
                updatesChecked={updatesChecked}
                emailError={emailError}
              />
            )}
          </>
        )}
      </FormWrapper>
      <StyledImage src={noNavigation ? MelTrialImage : Newsletter} />
    </NewsLetterSignUp>
  );
};

export default NewsletterSignUp;
